var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(!_vm.isMobileView)?_c('layout-page',[_c('up-next-page-desktop')],1):_c('layout-mobile',[_c('up-next-page-desktop')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }